import { Toaster, TooltipProvider } from '@crm/ui';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { CrmClient } from '../api/client.ts';
import { RouteErrorPanel } from '../components/route-error-boundary.tsx';

export type RouterContext = {
  readonly queryClient: QueryClient;
  readonly crm: CrmClient;
};

/**
 * The router context carries the query client and the API client, so a route's
 * `beforeLoad` / `loader` can prefetch without reaching for a module singleton —
 * which is also what makes a route testable against a stub client.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: RouteErrorPanel,
});

function RootLayout() {
  return (
    <TooltipProvider delayDuration={200}>
      <Outlet />
      <Toaster />
    </TooltipProvider>
  );
}
